export default {
  TAXES_FETCH_START: 'TAXES_FETCH_START',
  TAXES_FETCH_SUCCESS: 'TAXES_FETCH_SUCCESS',
  TAXES_FETCH_FAILURE: 'TAXES_FETCH_FAILURE',
}
